import cn from 'bem-cn';

import { Avatar, Stack } from '../../UI';
import { pluralize } from '../../../utils/pluralize/pluralize';

import { PromptInfoAuthorProps } from './PromptInfoAuthor.types';
import './PromptInfoAuthor.scss';

const b = cn('prompt-info-author');

export const PromptInfoAuthor = ({ author, subtitle, disabled }: PromptInfoAuthorProps) => {
    const { image, name, promptsCount } = author;

    const plural =
        promptsCount &&
        pluralize(promptsCount, {
            one: 'промпт',
            few: 'промпта',
            many: 'промптов',
        });

    // const authorLink = `/authors/${login}`;

    return (
        <Stack className={b({ disabled })}>
            <Stack direction="row" justifyContent="space-between" spacing={8} py={12} px={16} className={b('content')}>
                <Stack direction="row" alignItems="center" spacing={12}>
                    <Avatar image={image} size="medium" />
                    <Stack>
                        <p className={b('small-text', { secondary: true })}>{subtitle}</p>
                        <p className={b('name')}>{name}</p>
                    </Stack>
                </Stack>
                <Stack direction="row" spacing={8} alignItems="center">
                    {Boolean(promptsCount) && <p className={b('small-text')}>{plural}</p>}
                    {/* <Icon name="chevronRight" size={18} /> */}
                </Stack>
            </Stack>
        </Stack>
    );
};
